(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    /* MOVIQ: in productkaarten maximaal 5 kleurbolletjes, daarna een '+N'-teller die naar de productpagina linkt.
     Passen er geen 5 (bijv. mobiel), dan zoveel als er passen naast de teller.
     Verborgen kleuren (concept / geen voorraad of foto) tellen niet mee.
     De eigen 'meer'-functie van het thema (overflow-list) staat in kaarten uit, anders verplaatst die de teller.

     MOVIQ (snelheid): eerst alles in één keer opmeten, daarna alles in één keer aanpassen.
     De oude versie mat en wijzigde per kaart om en om, waardoor de browser bij elke filterklik
     24x de layout moest herberekenen (~200 ms per keer, meerdere keren per klik).
     Reageert alleen nog op wijzigingen in de productlijst en op venstergrootte. */
  (() => {
    if (window.__moviqSwatchLimit) return;
    window.__moviqSwatchLimit = true;

    const MAX_SWATCHES = 5;
    const COUNTER_WIDTH = 28;

    const scan = () => {
      const cards = [];
      document.querySelectorAll('.product-grid__card product-swatches').forEach((ps) => {
        const ol = ps.querySelector('overflow-list');
        if (!ol) return;
        // Fase 1: voorbereidende wijzigingen (hangen niet af van de layout)
        if (ol.getAttribute('disabled') !== 'true') ol.setAttribute('disabled', 'true');
        ol.querySelectorAll(':scope > [slot="overflow"]').forEach((el) => el.removeAttribute('slot'));
        const items = [...ol.querySelectorAll(':scope > li.variant-option__swatch')].filter((li) => !li.hasAttribute('hidden'));
        if (!items.length) return;
        cards.push({ ps, ol, items });
      });
      if (!cards.length) return;

      // Fase 2: alles opmeten (1 layoutberekening). Maat, tussenruimte en padding zijn voor elke kaart gelijk.
      let size = 0;
      let gap = 8;
      let padding = 0;
      for (const card of cards) {
        size = card.items[0].getBoundingClientRect().width;
        if (size > 0) {
          const list = card.ol.shadowRoot && card.ol.shadowRoot.querySelector('[part="list"]');
          if (list) {
            const style = getComputedStyle(list);
            gap = parseFloat(style.columnGap) || 0;
            padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
          }
          break;
        }
      }
      if (!size) return;
      for (const card of cards) card.width = card.ps.getBoundingClientRect().width;

      // Fase 3: alles aanpassen
      for (const { ps, ol, items, width } of cards) {
        if (!width) continue;
        let more = ol.querySelector(':scope > li.moviq-swatch-more');
        const available = width - padding;
        const fitsWithoutCounter = Math.floor((available + gap) / (size + gap));

        if (items.length <= Math.min(MAX_SWATCHES, fitsWithoutCounter)) {
          items.forEach((li) => li.classList.contains('moviq-swatch-extra') && li.classList.remove('moviq-swatch-extra'));
          if (more) more.remove();
          continue;
        }

        const fitsWithCounter = Math.floor((available - COUNTER_WIDTH) / (size + gap));
        const show = Math.max(1, Math.min(MAX_SWATCHES, fitsWithCounter));
        const hiddenCount = items.length - show;

        items.forEach((li, index) => {
          const extra = index >= show;
          if (li.classList.contains('moviq-swatch-extra') !== extra) li.classList.toggle('moviq-swatch-extra', extra);
        });

        if (!more) {
          more = document.createElement('li');
          more.className = 'moviq-swatch-more';
          more.appendChild(document.createElement('a'));
        }
        const link = more.firstElementChild;
        const href = ps.dataset.productUrl || '#';
        if (link.getAttribute('href') !== href) link.href = href;
        if (link.textContent !== '+' + hiddenCount) {
          link.textContent = '+' + hiddenCount;
          link.setAttribute('aria-label', 'Nog ' + hiddenCount + ' kleuren bekijken');
        }
        if (items[show - 1].nextElementSibling !== more) items[show - 1].after(more);
      }
    };

    let queued = false;
    const queueScan = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        scan();
      });
    };

    const isRelevantNode = (n) =>
      n.nodeType === 1 &&
      !n.classList.contains('moviq-swatch-more') &&
      (n.matches('product-swatches, li.variant-option__swatch, .product-grid__item, .product-grid') ||
        !!n.querySelector('product-swatches'));

    new MutationObserver((mutations) => {
      const relevant = mutations.some((m) => {
        if (m.type === 'attributes') {
          if (m.attributeName === 'product-grid-view') return true;
          if (m.attributeName === 'slot') return m.target.getAttribute('slot') === 'overflow';
          return m.target.matches && m.target.matches('li.variant-option__swatch');
        }
        return [...m.addedNodes].some(isRelevantNode);
      });
      if (relevant) queueScan();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'slot', 'product-grid-view'],
    });

    let lastWidth = window.innerWidth;
    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        queueScan();
      },
      { passive: true }
    );

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
